const ToastActionTypes = {
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE',
  MESSAGE: 'MESSAGE',
};

export default ToastActionTypes;
